export default "__VITE_ASSET__XuLyKE6d__"